import {
  TWEET_TEXT,
} from 'constants';

import track from 'lib/track';

const networkUrls = {
  twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(TWEET_TEXT)}`,
  facebook: 'https://www.facebook.com/sharer/sharer.php'
    + `?u=${encodeURIComponent(document.URL)}`
    + `&t=${encodeURIComponent(document.URL)}`,
};

export default function share(network) {
  const url = networkUrls[network];

  if (url) {
    window.open(url, 'share', 'height=500,width=500');
  }

  track('Social', 'Share', network);
}



// WEBPACK FOOTER //
// ./src/lib/share.js